<template>
    <div class="rangaistukset">
        <h1>Rangaistukset: mitä, miten</h1>
        <p>Taulukko rangaistuksista rangaistustaulukko sivulla.</p>
        <p>Tällä "oppaalla" opit käyttämään varoituksiin, banneihin liittyviä komentoja</p>

        <h3>Pelaajan tilan tarkastaminen</h3>
        <p>Ennen kuin pelaajaa ruvetaan rankaisemaan, on selvitettävä onko pelaajaa jo rankaistu rikkeestä.</p>
        <h4>Pelaajan bannihistorian tarkastaminen</h4>
        <Command
            moderaattori
            command="history"
            params="<pelaaja>"
            desc="näyttää pelaajan bannihistorian, mutta ei varoituksia"
        />
        <h4>Varoitusten määrän ja laadun tarkistaminen</h4>
        <Command
            moderaattori
            command="warnings"
            params="<pelaaja>"
            desc="Näyttää voimassa olevat varoitukset ja niiden varoitus-id:t"
        />

        <h3 id="varoitukset">Varoitukset</h3>
        <p>
            Varoituksia annetaan aina, kun varoitukseen on aihetta. Lista varoitusaiheista löytyy rangaistustaulukossa.
        </p>
        <p>Varoitukset laitetaan aina pituudeltaan 180 päivän mittaisiksi (180d)</p>
        <p>Saadessaan 3. aktiivisen varoituksen pelaaja saa automaattiset 14 päivän bannit.</p>
        <p>
            Kun 3. aktiivista varoitusta tulee uudemman kerran täyteen, saa pelaaja automaattisesti loputtomat bannit.
        </p>

        <h4>Varoituksen antaminen</h4>

        <Command
            moderaattori
            command="warn"
            params="&lt;pelaaja&gt; &lt;syy&gt;"
            desc="/warn on nykyään korvannut komennon /tempwarn"
            example="esim. /warn Susse Huono käyttäytyminen"
        />

        <Command
            desc="Jos varoitukseen liittyy joku tietty sijainti, muista lisätä varoitukseen koordinaatit."
            example="esim /warn Susse Npckylän grieffaus 1054 78 -543"
        />
        <p></p>

        <p>
            Ennen kuin pelaajalle annetaan varoitus, on syytä tarkastaa onko kyseisestä rikkeestä jo annettu rangaistus.
            Katso yltä 'varoitusten määrän tarkistaminen'. Toki jokaisesta rikkeestä varoitetaan erikseen, mutta esim
            samasta maisemagrieffistä ei varoiteta montaa kertaa.
        </p>
        <p>
            Pelaajalle täytyy antaa mahdollisuus reagoida. Esimerkiksi jos pelaaja on yhdessä päivässä tehnyt kolme
            pientä erillistä maisemagriefiä, ei häntä ole sopivaa rankaista jokaisesta erikseen. Varoitusten idea on
            varoittaa pelaajaa väärin tehdystä asiasta, eikä pienentää Karanteenin pelaajakuntaa.
        </p>
        <p>
            Jos pelaajalla on meneillään olevat bannit kyseisestä varoituksen aiheesta, ei pelaajalle anneta uutta
            varoitusta.
        </p>

        <h4>Varoituksen poistaminen</h4>
        <p>
            Jos antaa virheellisen tai aiheettoman varoituksen, tulee se poistaa pelaajalta komennolla /unwarn.
            Varoituksen poistamiseen tarvitaan varoitus-id jonka saa /warnings pelaaja.
        </p>
        <Command
            moderaattori
            command="unwarn"
            params="<id>"
            desc="Näet id:n komennolla /warnings <pelaaja>"
            example="esim. /warnings Susse -> löydät warnin idksi #2345 -> /unwarn 2345 -> warni poistettu"
        />
        <h4>Pelaajan kaikkien varoitusten poistaminen</h4>
        <Command
            moderaattori
            command="unwarn"
            params="clear <pelaaja>"
            desc="Poistaa pelaajan kaikki varoitukset"
            example=""
        />
        <h3 id="bannit">Bannit</h3>
        <p>
            Bannien pituudet määritellään pelaajan rankin, pelaajan entisten rikkeiden, ja tehdyn rikkeen mukaan
            rangaistustaulukosta.
        </p>
        <h4>Bannien antaminen</h4>
        <Command
            moderaattori
            command="ban"
            params="<pelaaja> <aika> <syy>"
            example="HUOM ILMAN AIKAA BÄNNÄÄMINEN ON PERMABAN! esim. /ban Susse 14d Jatkuva huono käyttäytyminen varoituksista huolimatta"
        />
        <h4>Permabannien antaminen</h4>
        <p>Permabanneihin vaaditaan vähintään operaattori</p>
        <Command operaattori command="ban" params="<pelaaja>" example="esim. /ban Susse Timanttien dupettaminen" />
        <h4>Ip-bannien antaminen</h4>
        <Command
            operaattori
            command="ipban"
            params="<pelaaja> <aika> <syy>"
            example="esim. /ipban Susse 180d Timanttien dupettaminen"
        />
        <h4>Bannien poistaminen</h4>
        <p>Vain adminit ja omistajat voivat poistaa banneja. Tarvittaessa delegoi.</p>
        <Command admin command="pardon" params="<pelaaja>" example="esim. /pardon Susse" />
    </div>
</template>

<script>
import Command from '@/components/Command'

export default {
    name: 'rangaistukset',
    components: {
        Command
    },
    metaInfo: {
        title: 'Rangaistukset'
    }
}
</script>

<style scoped>
.rangaistukset {
    margin-bottom: 6em;
}
</style>
